module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "sidebar-in-out"
    }
  }, [(_vm.showSidebar) ? _c('sidebar', {
    attrs: {
      "id": "fif-sidebar"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'sidebar': _vm.showSidebar
    },
    attrs: {
      "id": "fif-content"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-in-out"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), (_vm.popover) ? _c('div', {
    staticClass: "intro-popover"
  }, [_c('div', {
    staticClass: "popover-content"
  }, [_c('a', {
    staticClass: "fa fa-close",
    on: {
      "click": function($event) {
        _vm.popover = false
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h4', [_vm._v("Welcome to the Forests in Focus Prototype.")]), _vm._v(" "), _c('p', [_vm._v("Forests in Focus is a joint effort by GreenBlue's Forest Products Working Group and the American Forest Foundation. The goal of this Forests in Focus initiative is to bring together the full value chain from brand owners to family forest owners to pro-actively engage in achieving shared sustainability outcomes.")]), _vm._v(" "), _c('p', [_vm._v("Please note, this Prototype has been developed for the sole purpose for exploring and discussing, at a conceptual level, strategies for bringing visibility and transparency to responsible forest management. This is not a working tool to be used in any capacity except to share feedback to GreenBlue and the American Forest Foundation.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrapper"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/fif-logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_vm._v("\n  For more information, and to provide feedback,\n  please email "), _c('a', {
    attrs: {
      "href": "mailto:fif@greenblue.org"
    }
  }, [_vm._v("fif@greenblue.org")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ad251fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 116
// module chunks = 0